const devStages = [
  '.dev.',
  '.dev-02.',
  '.dev-03.',
  '.dev-04.',
  '.dev-05.',
  '.dev-06.',
  '.dev-07.',
  'localhost',
]

export function isDev() {
  let isDev = false
  devStages.forEach((stage) => window.location.origin.includes(stage) && (isDev = true))

  return isDev
}

export function devLog(...toLog: any[]) {
  let shouldLog = false
  devStages.forEach((stage) => window.location.origin.includes(stage) && (shouldLog = true))

  if (shouldLog) {
    console.log(...toLog)
  }
}
